"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const Keys_1 = require("./constants/Keys");
let Mixpanel;
let mixpanel;
let ReactGA;
mixpanel = require("mixpanel-browser").default;
ReactGA = require("react-ga4").default;
const init = (prod, user) => __awaiter(void 0, void 0, void 0, function* () {
  const disableTrack = Keys_1.default.getDisableTrack();
  if (!disableTrack) {
    //Init Mixpanel
    const TOKEN = prod ? "0e485d5dc010ad2121fa45ec846cd0d2" : "2e61e127e939834e01479c5f68dca202";
    mixpanel.init(TOKEN, {
      debug: prod ? false : true,
      track_pageview: false,
      record_sessions_percent: prod ? 10 : 0,
      record_collect_fonts: true,
      record_min_ms: 10000,
      record_mask_text_selector: "",
      record_block_selector: ""
    });
    mixpanel.set_config({
      persistence: "localStorage"
    });

    //Init Google Analytics

    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.initialize(prod ? "G-NQ3VVY868C" : "G-KCB5B7F3C7");
    if (user) {
      updatePeople(user);
    }
  }
});
const event = data => {
  var _a, _b;
  const disableTrack = Keys_1.default.getDisableTrack();
  if (!disableTrack) {
    //Get utm data
    const utmData = Keys_1.default.getUtmData();
    //Mixpanel
    mixpanel.track(data.event, Object.assign(Object.assign({}, data.params), {
      utm_source: utmData === null || utmData === void 0 ? void 0 : utmData.source,
      utm_medium: utmData === null || utmData === void 0 ? void 0 : utmData.medium,
      utm_campaign: utmData === null || utmData === void 0 ? void 0 : utmData.campaign,
      utm_term: utmData === null || utmData === void 0 ? void 0 : utmData.term,
      utm_content: utmData === null || utmData === void 0 ? void 0 : utmData.content
    }));
    //GA4

    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.event(data.event, Object.assign(Object.assign({}, data.params), {
      user_id: (_b = data.user) === null || _b === void 0 ? void 0 : _b.objectId,
      source: utmData === null || utmData === void 0 ? void 0 : utmData.source,
      medium: utmData === null || utmData === void 0 ? void 0 : utmData.medium,
      campaign: utmData === null || utmData === void 0 ? void 0 : utmData.campaign,
      term: utmData === null || utmData === void 0 ? void 0 : utmData.term,
      content: utmData === null || utmData === void 0 ? void 0 : utmData.content
    }));
  }
};
const pageView = data => {
  const utmData = Keys_1.default.getUtmData();
  ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.send({
    hitType: "pageview",
    page: data.path,
    title: data.title,
    source: utmData === null || utmData === void 0 ? void 0 : utmData.source,
    medium: utmData === null || utmData === void 0 ? void 0 : utmData.medium,
    campaign: utmData === null || utmData === void 0 ? void 0 : utmData.campaign,
    term: utmData === null || utmData === void 0 ? void 0 : utmData.term,
    content: utmData === null || utmData === void 0 ? void 0 : utmData.content
  });
};
const updatePeople = user => __awaiter(void 0, void 0, void 0, function* () {
  const disableTrack = Keys_1.default.getDisableTrack();
  if (!disableTrack) {
    const userId = user.objectId;
    const name = user.name;
    const surname = user.surname;
    const email = user.email;
    const phone = user.phone;
    const state = user.state;
    const gender = user.gender;
    const birthday = user.birthday;
    const coorp = user.Coorporate;
    //Identify the user in Mixpanel
    mixpanel.identify(user.objectId);
    mixpanel.people.set({
      id: userId,
      Coorporate: coorp ? coorp.objectId : null,
      $first_name: name,
      $last_name: surname,
      $email: email,
      $phone_number: phone,
      state: state,
      gender: gender,
      birthday: birthday
    });

    //Identify the user in GA4

    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.gtag("set", "user_properties", {
      name: name,
      surname: surname,
      email: email,
      phone: phone,
      state: state,
      gender: gender,
      birthday: birthday === null || birthday === void 0 ? void 0 : birthday.iso,
      Corporate: coorp ? coorp.objectId : null
    });
  }
});
const charge = (transactionId, product) => {
  const disableTrack = Keys_1.default.getDisableTrack();
  if (!disableTrack) {
    mixpanel.people.track_charge(product.price);
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.event("purchase", {
      transaction_id: transactionId,
      value: product.price,
      currency: product.currency,
      tax: 0,
      shipping: 0,
      items: [{
        item_name: product.name,
        item_id: product.objectId,
        price: product.price,
        quantity: 1
      }]
    });
  }
};
const getDistinctId = () => __awaiter(void 0, void 0, void 0, function* () {
  return mixpanel.get_distinct_id();
});
exports.default = {
  charge,
  init,
  event,
  getDistinctId,
  pageView,
  updatePeople
};